import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import CreateMetro from '../Components/CreateMetro';
import { useNavigate } from 'react-router-dom';

const CreateMetroAdmin = () => {
    const navigate = useNavigate();
    const [userlog, setUserlog] = useState(localStorage.getItem('Logkey'));
    useEffect(() => {
        if (userlog === undefined || userlog === null) {
            navigate("/")
        }
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <CreateMetro />
            {/* <Footer/>   */}
        </>
    )
}

export default CreateMetroAdmin
